import React, { useState, useEffect } from "react";
import "../ComponentsCSS/Navbar.css";
import { Link, useLocation } from "react-router-dom";

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const closeMenu = () => {
    setIsOpen(false);
  };

  // Handle scroll background change
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Close menu on route change
  useEffect(() => {
    closeMenu();
  }, [location]);

  // Lock body scroll when menu is open
  useEffect(() => {
    if (isOpen) {
      document.body.classList.add("menu-open");
    } else {
      document.body.classList.remove("menu-open");
    }
  }, [isOpen]);

  return (
    <div className={`navbar ${scrolled ? "scrolled" : ""}`}>
      <div className="container">
        <div className="logo">
          <Link to="/" className="head">
            <img className="img-fluid" src="./assets/logo.png" alt="logo" />
            SASK A One Shuttle
          </Link>
        </div>

        <div className="right-section">
          <div className={`nav-links ${isOpen ? "open" : ""}`}>
            <Link className="links" to="/" onClick={closeMenu}>
              Home
            </Link>
            <Link className="links" to="/about" onClick={closeMenu}>
              About
            </Link>
            <Link className="links" to="/services" onClick={closeMenu}>
              Services
            </Link>
            {/* <Link className="links" to="/contact" onClick={closeMenu}>
              Contact
            </Link> */}
            <Link to="/bookNow" onClick={closeMenu}>
              <button className="book-now">
                Book Now 24<sub>/7</sub>
              </button>
            </Link>
          </div>

          <div
            className={`menu-icon ${isOpen ? "open" : ""}`}
            onClick={toggleMenu}
          >
            <div className="bar bar1"></div>
            <div className="bar bar2"></div>
            <div className="bar bar3"></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Navbar;
